export const NavBar = ({ children }) => {
  return (
    <div className="uk-position-top">
      <nav className="uk-navbar-container uk-navbar-transparent" uk-navbar="">
        <div className="uk-navbar-right uk-padding-small">{children}</div>
      </nav>
    </div>
  );
};
